import { SEARCH_STACK_SUGGESTIONS_DICTIONARY } from "constants/stack";
import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";

import useStackListAnalytics from "../useStackListAnalytics";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    trackAnalytics: useStackListAnalytics(),
    searchSuggestionsDictionary: SEARCH_STACK_SUGGESTIONS_DICTIONARY,
  })(props);
};

export default useCellFilterAction;
